var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('span',{staticClass:"explanation-icon"},[_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.getLinkifiedDescription, trigger: 'click' }),expression:"{ content: getLinkifiedDescription, trigger: 'click' }"}],class:['pointer', 'material-icons', _vm.type]},[_vm._v(_vm._s(_vm.icon))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-104ea8ea","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/general/IconTooltip.vue
// module id = Y9kW
// module chunks = 0 1